<template>
  <el-main :style="{height:height+'px'}" v-loading="loading">
    <div class="Scroll_content">

      <div v-if="list.length != 0">
        <div v-for="(item,index) in list" :key="index">
          <div class="title_older">{{ item.title}}</div>
          <div class="list_content" v-for="(items,index) in item.list" :key="index">
            <div class="left_content">
              <div class="time_text">
                <div class="title_content">{{items.subject_title}}  <span v-if="items.attends_status==1" class="qingjia"> ({{$t('main.leave')}})</span></div>
                <div class="timecontent">
                  {{items.start_time}} - {{items.end_time}}
                  <button :class="items.status==0&&items.mins&&!items.enterStatus?'willStartIn':((items.status==1)?'pending':(items.status==2?'completed':'btnNone'))">
                    <span class="dot"></span>
                    {{items.status==0&&items.mins&&!items.enterStatus?$t('main.timeOut')+items.mins+$t('main.timeOut_1'):(items.status==1?$t('main.OnAir'):(items.status==2?$t('main.completed'):(items.status==3?$t('main.cancel'):'')))}}
                  </button>
                </div>
              </div>
              
              <el-popconfirm
                v-if="items.is_attends&&items.sickStatus"
                :confirm-button-text="$t('main.requestLeave')"
                cancel-button-text=' '
                :hide-icon="true"
                @confirm="handleCommand(items)"
              >
                <el-button slot="reference"></el-button>
              </el-popconfirm>
                <!-- <el-dropdown @command="handleCommand(items)" class="LeavePopover" trigger="click">
                  <el-button class="rightHead">
                    <i class="el-icon-more"></i>
                  </el-button>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item class="sickPop" command="sickLeave">{{$t('main.requestLeave')}}</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown> -->
            </div> 
            <div class="content_box">
              
              <div class="title_content_bom">
                <!-- <div class="dom" >{{items.duration}}mins</div>   -->
                <div class="dom">
                  <p>{{$t('new_test1.Level')}}</p> <span>{{items.level_title}}</span></div>  
                <div class="dom">
                  <p>{{$t('new_test1.Topic')}}</p> <span>{{items.lesson_topic?items.lesson_topic:'-'}}</span></div>  
              </div>
              
              <div class="send_botton">
                  <el-popover
                    v-if="items.attends_status==1||items.status==3||items.status==2||((items.status==0||items.status==1)&&!items.enterStatus)"
                    placement="bottom"
                    width="230"
                    trigger="hover"
                    :content="$t('main.beginToEnter')">
                    <!-- <img class="icon_wen" slot="reference" src="../../assets/Ellipse106.svg" alt="">  -->
                    <div class="bunmers" slot="reference">{{$t('main.enterClassRoom')}}</div> 
                  </el-popover>
                  <div class="bunmer" slot="reference" @click="enterClassRoom(items)" v-else>{{$t('main.enterClassRoom')}}</div> 
              </div>
            </div>


            <!--判断按钮存在不存在
              v-if="items.is_attends&&items.sickStatus"-->
            <!-- <el-popover
              placement="right"
              width="0"
              trigger="click">
              <span class="sqjiax" @click="leave(items)">{{$t('main.requestLeave')}}</span>
              <div class="qingjiaka" slot="reference" v-if="items.is_attends&&items.sickStatus">
                <img class="list_icon" src="../../assets/Ellipse129.svg" alt="">
                <img class="list_icon" src="../../assets/Ellipse129.svg" alt="">
                <img class="list_icon" src="../../assets/Ellipse129.svg" alt="">
              </div> 
            </el-popover> -->


          </div>
          <div class="dian"></div>

        </div>
      </div>
      <div v-else class="noResultInfo">
        <p class="font_24_reg">{{$t('tabBar.noLesson')}}</p>
        <p class="font_24_reg">{{$t('tabBar.download')}}</p>
        <div class="flex_justify_center">
          <img @click="utils.toAppStore()" src="../../assets/Download_App_Store.svg" style="margin-right: 20px;" />
          <img @click="utils.toGooglePlay()" src="../../assets/google-play-badge.png" />
        </div>
      </div>

      <div v-if="isShoSick" class="el-message-box__wrapper" style="z-index: 2010;background:rgb(0 0 0 / 30%)">
        <div class="el-message-box">
          <div class="el-message-box__header">
            <div class="el-message-box__title center">
              {{$t('main.sickTitle')}}
            </div>
            <button type="button" class="el-message-box__headerbtn" @click="chooseImg">
              <i class="el-message-box__close el-icon-close"></i>
            </button>
          </div>
          <div class="el-message-box__content">
            <div class="el-message-box__container">
              <div class="el-message-box__message">
                <p class="center">{{$t('main.askTo')}} <b>{{commandData.nickname}}</b> {{$t('main.currentCredit')}}</p>
                <div class="leaveInfo">
                  <p>{{commandData.subject_title}}</p>
                  <p>{{commandData.start_time}} - {{commandData.end_time}}</p>
                  <p>{{commandData.start_date}}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="el-message-box__btns">
            <button type="button" class="el-button el-button--default el-button--small el-button--primary" @click="submitSick">
              <span>{{$t('main.confirmSick')}}</span>
            </button>
          </div>
        </div>
      </div>

    </div>
  </el-main>
  
</template>
<script>
  import { setStore, getStore, keys } from '@/store';
  // import IndexHeader from '../views/header'
  // import IndexFooter from '../views/footer'
  // import MyScheduled from '../views/scheduled'
  // import MyCourse from '../views/course'
  // import PastLesson from '../views/lesson'

  //引入header组件
  // import Header from '../header/header'

  export default {
    components: {
      // IndexHeader,
      // IndexFooter,
      // MyScheduled,
      // PastLesson,
      // MyCourse,
      // Header
    },
    data () {
      return {
        height:100,
        searchStudentSn:'',
        Page_size:'30',
        Page_num:'1',
        list:[],
        loading:false,
        isShoSick:false,
        commandData:{},
        timing:null
      }
    },
    created () {
      let height = document.body.offsetHeight-80;
      this.height = height
      if (getStore(keys.token)) {
        if (getStore(keys.userInfo).status == 0) {
          this.$router.push({
            path: '/sinadd'
          })
        }
      } else {
        this.$router.push({
          path: '/'
        })
        return false
      }
      // this.getUser();
      // 账户信息
      this.getBalance()
      // this.Book_a_course();
      // this.timeStatus();
      this.timing = setInterval(() => { 
        this.format_time()
        this.$forceUpdate()
      
      }, 1000)
    },
    methods: {
      getBalance () {
        this.$http.get('/api/accounts?model=lessons').then((res) => {
          if (res.data.code == 200) {
            let balanceData = res.data.data
            setStore(keys.userBalance,res.data.data)
            if(!balanceData.language) {
              console.log(navigator.language)
              var termn=(navigator.language.toLowerCase().includes('zh-cn')?'zh_CN':navigator.language)
              this.$http.post('/api/setUserLanguage', {language: termn})
              .then((res) => {

				      setStore(keys.lang, termn);
            
              this.$i18n.locale = getStore(keys.lang)
              })
              .catch((error) => {
              console.log(error) // 请求失败返回的数据
              })
            }
            else if(balanceData.language){
              setStore(keys.lang, balanceData.language);
              this.$i18n.locale = getStore(keys.lang)
            }
            this.Book_a_course ()
          } else {
            this.$message({
              message: res.data.msg,
              type: 'warning'
            })
          }
        }).catch((error) => {
          console.log(error) // 请求失败返回的数据
        })
      },
      /**
       * 获取预约课程列表方法
       */
      Book_a_course () {
        let _this = this;
        let children_id = getStore(keys.userProfile).last_student_sn;
        if(!children_id){
          _this.getUser();
        }else{
          _this.get_kechen();
        }
        

      },
      get_kechen(){
        let _this = this;
        this.loading = true;
        let children_id = getStore(keys.userProfile).last_student_sn;
        this.$http.get('/api/userSchedukeForStudentSeven?type=1001&student_sn=' + children_id + '&time_diff=' + this.utils.timeZone() + '&pagesize=' + this.Page_size + '&page=' + this.Page_num).then((res) => {
          if (res.data.code == 200) {
            let Array_list = res.data.data
            for(let i=0;i<Array_list.length;i++){
              Array_list[i].list = [];
              Array_list[i].list.push(Array_list[i].data)
            }
            _this.list = Array_list
            _this.loading = false
          } else {
            _this.$message({
              message: res.data.msg,
              type: 'warning'
            })
          }
        }).catch((error) => {
          console.log(error) // 请求失败返回的数据
        })
      },
      /**
       * 时间格式化方法
       */
      format_time(){
        let Array_list = this.list;
        for(var i=0;i<Array_list.length;i++){
          var hoursRound = ''
          var minutesRound = ''
          let beg = this.utils.formatDate(Array_list[i].list[0].start_at).getTime() // 开始秒数
          let now = new Date().getTime()
          let begTime = beg - now
          if (begTime > 0 && begTime < 172800000) {
            hoursRound = Math.floor(begTime / 1000 / 60 / 60)
            minutesRound = Math.floor(begTime / 1000 / 60 % 60)
            Array_list[i].list[0].mins = hoursRound + (hoursRound>0?this.$t('main.hours') :this.$t('main.hr') ) +  minutesRound + this.$t('main.mins')
          }
          if (begTime < 300000) { // 五分钟内才能进入教室
            Array_list[i].list[0].enterStatus = true
          }
          if (begTime > 10800000) {
            Array_list[i].list[0].sickStatus = true
          }
        }
        this.list = Array_list;
      },
      /**
       * 进入教室
       */
      enterClassRoom (dataJson) {
        this.$http.post('/api/judeLessonStatus', {lesson_sn: dataJson.lesson_sn, student_sn: dataJson.student_sn}).then((res) => {
          
          if(res.data.code==200){
            if(res.data.data.is_class){
              
              this.$http.post('/api/enterRoom', {lesson_sn: dataJson.lesson_sn, student_sn: dataJson.student_sn}).then((res) => {
                window.open(res.data.data.url)
              }).catch((error) => {
                console.log(error) // 请求失败返回的数据
              })
            }else{
              this.$message({
                message: res.data.data.message,
                type: 'warning'
              })
            }

          }else{
            this.$message({
              message: res.data.msg,
              type: 'warning'
            })
          }
        }).catch((error) => {
          console.log(error) // 请求失败返回的数据
        })

      },
      /**
       * 请假
       */
      // leave(items){
      //   this.isShoSick = true
      //   this.commandData = items
      // },
      handleCommand (command) {
        this.isShoSick = true
        this.commandData = command
      },
      /**
       * 确认请假方法
       */
      submitSick () {
        let _this = this;
        this.$http.post('/api/edu/lesson-attends', {
          lesson_sn: this.commandData.lesson_sn,
          student_sn: this.commandData.student_sn
        }).then((res) => {
          if (res.data.code == 200) {
            this.isShoSick = !this.isShoSick
            this.$notify({
              message: res.data.msg,
              duration: 0
            })

            _this.Book_a_course();
            // this.dataschedule.map((item) => {
            //   if (item.lesson_sn == res.data.data.lesson_sn && item.student_sn == res.data.data.student_sn && res.data.data.status != 0) {
            //     item.is_attends = false
            //   }
            // })
            // this.$forceUpdate()

            
          } else {
            this.$message({
              message: res.data.msg,
              type: 'warning'
            })
          }
        }).catch((error) => {
          console.log(error) // 请求失败返回的数据
        })
      },
      chooseImg () {
        this.isShoSick = !this.isShoSick
      },
      //用于首次进入更新换成数据
      getUser () {
        let _this = this;
        this.$http.get('/api/user/profile').then((res) => {
          if (res.data.code == 200) {
            setStore(keys.userProfile, res.data.data)
            _this.get_kechen();
          } else {
            _this.$message({
              message: res.data.msg,
              type: 'warning'
            })
          }
        }).catch((error) => {
          console.log(error) // 请求失败返回的数据
        })
      },
    },
    mounted () {

    },
    beforeDestroy(){
      /**
       * 离开该模块，利用生命周期结束定时器
       */
      if(this.timing){
        clearInterval(this.timing);
      }
    },
    watch: {
      '$intercom.visible': function (val) {
        if (val == true) {
          this.updateIntercom()
        }
      },
      email (email) {
        this.$intercom.update({email})
      }
    },
    
  }
</script>
<style lang="less" scoped>

.el-main{
  overflow: inherit;
}
.left_body_content{
    // width: 358px;
  // height: 900px;
  // border: 1px solid ;
  // position: fixed;
  // top: 84px;
  // bottom: 0;
  // background: #FCFCFF;
  // border: 1px solid red;
  .left_nav_content{
    width: 358px;
    height: 900px;
    // border: 1px solid ;
    position: fixed;
    top: 84px;
    bottom: 0;
    background: #FCFCFF;
  }
  .right_content{
    // width: 400px;
    // height: 400px;
    // border: 1px solid red;
    // margin-left: 358px;
  }
}


.Scroll_content{
  // width: 1012px;
  height: 400px;
  // border:1px solid red;
  .list_content{
    // height: 140px;
    background: #FFFFFF;
    border: 1px solid rgba(0, 0, 0, 0.09);
    box-shadow: 0px 4px 26.64px rgba(0, 0, 0, 0.09);
    border-radius: 9px;
    box-sizing: border-box;
    margin-top: 17px;
    .left_content{
      // width: 147px;
      font-family: Sofia Pro;
      font-style: normal;
      display: flex;
      justify-content: space-between;
      border-bottom: 1px solid #E9E9E9;
      padding-bottom:10px;
      .time_text{
            // height: 80px;
            // line-height: 80px;
            font-size: 32px;
            margin: 12px 0 10px 33px;
            // margin-top: 27px;
            // text-align: center;
            // line-height: 80px;
            // border-right: 1px solid #F4F4F4;
            
          .title_content{
            font-family: Sofia Pro;
            font-style: normal;
            font-weight: 500;
            font-size: 24px;
            color: #000000;
            margin-bottom:10px;
          }
          .timecontent{
            display: flex;
            align-items: center;
            button{
              margin-left:30px;
            }
          }
      }
    }
    .content_box{
      // width: 550px;
      // height: 90px;
      border: 0px solid red;
      // margin-top: 24px;
      margin:20px 40px 20px 33px;
      flex:1;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .title_content_bom{
        display: flex;
        // margin-left: 35px;
        // margin-top: 19px;
        .dom{
          // margin-right: 49px;
          p{
            font-size: 20px;
            color: #000000;
          }
          span{
            font-size: 16px;
            color: #6B6B6B;
            display: block;
            min-width:162px;
            margin-top:10px;
          }
        }
      }
      
      .send_botton{
        // width: 267px;
        // height: 136px;
        display: flex;
        margin-left:30px;
        
        .bunmer{
          width: 183px;
          height: 50px;
          background: #4B4EFC;
          border-radius: 6px;
          font-family: Sofia Pro;
          font-style: normal;
          font-weight: bold;
          font-size: 18px;
          line-height: 50px;
          align-items: center;
          text-align: center;
          color: #FFFFFF;
          margin-top: 16px;
          cursor: pointer;
        }
      }
    }
    // .send_botton{
    //   width: 203px;
    //   height: 50px;
    //   background: #4B69FE;
    //   border-radius: 50px;
    // }
    /deep/ .el-dropdown{
      width: 37px;
      height: 37px;

      // background: #fff;
      border-radius: 6px;
      margin-right:40px;
      margin-top:20px;
      // .focusing{
      //   width: 37px;
      //   height: 37px;

      //   background: #4B4EFC;
      //   border-radius: 6px;
      //   img{
      //     width:32px;
      //   }
      // }
      .rightHead{
        // background: none;
        border:none;
        // color:#fff;
        font-size: 32px;
        padding:0;
        span{
          i{
            
            width:37px;
            height:37px;
            transform: rotateY(90deg);
          }
          img{
            width:37px;
            height:37px;
          }
        }

      }
    }
  }
}
  .title_older{
    font-family: Sofia Pro;
    font-style: normal;
    font-weight: 600;
    font-size: 27px;
    line-height: 27px;
    color: #000000;
    margin-top: 18px;
  }
  .qingjiaka{
    border:0px solid red;
    // margin-right: 10px;
    width: 13px;
    position: relative;
    right: 15px;
    cursor: pointer;
  }
  .list_icon{
    width: 5.52px;
    height:5.52px;
    display: block;
    margin-top:5px;
    
  }
  .sqjiax{
    cursor: pointer;
    font-size: 24px;
    font-family: Sofia Pro-Regular;
  }
  .bunmers{
      width: 203px;
      height: 50px;
      background: #E7E7E7;
      border-radius: 6px;
      font-family: Sofia Pro;
      font-style: normal;
      font-weight: bold;
      font-size: 18px;
      line-height: 50px;
      align-items: center;
      text-align: center;
      color: #FFFFFF;
      margin-top: 16px;
      cursor: pointer;
  }
  .cor{
    color: #FF6440 !important;
  }
  .cod{
    color: #009A91 !important;
  }
  .qingjia{
    color: red;
  }
  .icon_winm{
    position: relative;
    top: -2px;
    margin-right: 17px;
}


  .noResultInfo{
    margin-top:80px;
    text-align: center;
    p{
      margin-bottom:32px;
    }
  }
  
  .el-message-box__btns button{
    // width: 203px;
    height: 50px;
    background: #4B69FE;
    border-radius: 50px;
    border:none;
    font-family: Sofia Pro;
    font-style: normal;
    font-weight: bold;
    font-size: 18px;
    text-align: center;
    color: #FFFFFF;
    margin-top: 45px;
    cursor: pointer;
  }
  .el-message-box{
    background: #fff;
    
    .el-message-box__header{
        padding:20px 0;
        font-size:16px;
        color: rgba(0, 0, 0, 0.85);
        box-shadow: inset 0px -1px 0px #F0F0F0;
        .el-message-box__title{
          font-size:16px;
        }
    }
    .el-message-box__content{
      padding-top:0;
      .el-message-box__message{
        padding-left:0;
        p{
          font-size:16px;
        }
        >p{
            margin:24px 0 16px;
          }
      }
    }
    .el-message-box__btns{
      box-shadow: inset 0px 1px 0px #F0F0F0;
      margin:0;
      padding:10px 15px 0;
       button{
         margin:0;
         box-shadow: 0px 2px 0px rgba(0, 0, 0, 0.043);
          border-radius: 2px;
          font-size: 14px;
          font-weight: 700;
       }
    }
  }
  .leaveInfo{
    display: flex;
    justify-content: center;
    margin:16px auto 20px;
    p{
      color: #969696;
      font-size: 16px;
      border-right:1px solid #969696;
      padding:0 10px;
      &:nth-child(3n){
        border:none;
      }
    }
  }
  .el-message-box__wrapper .el-message-box__btns button{
    width: 203px;
  }
  
/deep/ .el-button.el-popover__reference{
  padding:0;
  
  width: 37px;
  height: 37px;
  border:none;
  background: url('../../assets/more.svg');
  border-radius: 6px;
  margin-right:40px;
  margin-top:20px;
  &:focus{
    background: url('../../assets/more-one.svg');
  }
}
</style>



// WEBPACK FOOTER //
// src/components/children/AttendClassNow.vue